export const breakpoints = {
  small: {
    'min-width': '23rem'
  },
  medium: {
    'min-width': '48rem'
  },
  large: {
    'min-width': '64rem'
  },
  xlarge: {
    'min-width': '75rem'
  }
}
